const KEY_SESSION_PAGE_COUNT = 'sessionPageCount';
const ECOM_PRODUCT_IMPRESSION = 'productImpression';
const ECOM_PRODUCT_CLICK = 'productClick';
const ECOM_PRODUCT_DETAIL = 'productDetail';
const ECOM_PRODUCT_CART = 'addToCart';
const ECOM_PRODUCT_CHECKOUT = 'checkout';
const ECOM_PRODUCT_PROMO_IMPRESSION = 'promotionImpression';
const ECOM_PRODUCT_PROMO_CLICK = 'promoClick';
const ECOM_PRODUCT_PURCHASE = 'purchase';

const EVENT_PAGEVIEW = 'e_ga_pageview';
const EVENT_EVENT = 'e_ga_event';
const EVENT_FORM_ERROR = 'e_form_error';
const EVENT_SOCIAL = 'e_ga_social';
const EVENT_PERF_USER_TIMING = 'e_ga_user_timing';
const EVENT_PERF_WEB_VITALS = 'e_ga_web_vitals';
const EVENT_ECOM_PRODUCT_IMPRESSION = 'ecommerce_productImpression';
const EVENT_ECOM_PRODUCT_CLICK = 'ecommerce_productClick';
const EVENT_ECOM_PRODUCT_DETAIL = 'ecommerce_productDetail';
const EVENT_ECOM_PRODUCT_CART = 'ecommerce_addToCart';
const EVENT_ECOM_PRODUCT_CHECKOUT = 'ecommerce_checkout';
const EVENT_ECOM_PRODUCT_PROMO_IMPRESSION = 'ecommerce_promotionImpression';
const EVENT_ECOM_PRODUCT_PROMO_CLICK = 'ecommerce_promoClick';
const EVENT_ECOM_PRODUCT_PURCHASE = 'ecommerce_purchase';

export const trackingConstants = {
    KEY_SESSION_PAGE_COUNT,
    ECOM_PRODUCT_IMPRESSION,
    ECOM_PRODUCT_CLICK,
    ECOM_PRODUCT_DETAIL,
    ECOM_PRODUCT_CART,
    ECOM_PRODUCT_CHECKOUT,
    ECOM_PRODUCT_PROMO_IMPRESSION,
    ECOM_PRODUCT_PROMO_CLICK,
    ECOM_PRODUCT_PURCHASE,
} as const;

export const eventTypeConstants = {
    EVENT_ECOM_PRODUCT_IMPRESSION,
    EVENT_ECOM_PRODUCT_CLICK,
    EVENT_ECOM_PRODUCT_DETAIL,
    EVENT_ECOM_PRODUCT_CART,
    EVENT_ECOM_PRODUCT_CHECKOUT,
    EVENT_ECOM_PRODUCT_PROMO_IMPRESSION,
    EVENT_ECOM_PRODUCT_PROMO_CLICK,
    EVENT_ECOM_PRODUCT_PURCHASE,
    EVENT_PAGEVIEW,
    EVENT_EVENT,
    EVENT_FORM_ERROR,
    EVENT_SOCIAL,
    EVENT_PERF_USER_TIMING,
    EVENT_PERF_WEB_VITALS,
} as const;

//GA4 constants
const EVENT_AB_TESTING = 'ab_testing';
const EVENT_AUCTION_BID = 'auction_bid';
const EVENT_PAYMENT_INFO = 'add_payment_info';
const EVENT_WISHLIST = 'add_to_wishlist';
const EVENT_SELECT_ITEM = 'select_item';
const EVENT_VIEW_ITEM = 'view_item';
const EVENT_VIEW_ITEM_LIST = 'view_item_list';
const EVENT_CONTACT_DEALER = 'contact';
const EVENT_VIEW_PROMOTION = 'view_promotion';
const EVENT_SELECT_PROMOTION = 'select_promotion';
const EVENT_SIGN_UP = 'sign_up';
const EVENT_LOGIN = 'login';
const EVENT_REGISTRATION = 'registration';
const EVENT_SHARE = 'share';
const EVENT_PURCHASE = 'purchase';
const EVENT_PRODUCT_INTERACTION = 'product_interaction';
const EVENT_ADD_CART = 'add_to_cart';
const EVENT_SEARCH = 'search';
const EVENT_PROMO_INTERACTION = 'promo_interaction';
const EVENT_RESULT_INTERACTION = 'results_interaction';
const EVENT_ITEM_UPLOAD_INTERACTION = 'item_upload_interaction';
const EVENT_BULK_ITEM_UPLOAD = 'bulk_item_upload_interaction';
const EVENT_ITEM_UPLOAD_COMPLETE = 'item_upload_complete';
const EVENT_DASHBOARD_INTERACTION = 'dashboard_interaction';
const EVENT_LISTING_INTERACTION = 'listing_interaction';
const EVENT_CONTACT_1STDIBS = 'contact_1stdibs';
const EVENT_INTL_INTERACTION = 'intl_interaction';
const EVENT_CHECKOUT_INTERACTION = 'checkout_interaction';
const EVENT_NAVIGATION = 'navigation';

const TRIGGER_BID_CLICK = 'bid click';
const TRIGGER_BID_INCREASE = 'increase bid click';
const TRIGGER_PDP_PURCHASE = 'pdp-purchase';
const TRIGGER_PDP_MAKE_OFFER = 'pdp make offer button';
const TRIGGER_PRIVATE_OFFER = 'private offer';
const TRIGGER_MORE_FROM_DEALER = 'more from dealer module';
const TRIGGER_CART_PURCHASE = 'cart-purchase';
const TRIGGER_MY_ORDERS_ACCEPT_OFFER = 'my orders-accept offer';
const TRIGGER_INVOICE_PURCHASE = 'invoice-purchase';
const TRIGGER_AUTOMATED_PRIVATE_OFFER = 'automated-private-offer';
const TRIGGER_EMAIL_MAKE_OFFER = 'email-make offer';
const TRIGGER_EMAIL_ACCEPT_OFFER = 'email-accept offer';
const TRIGGER_EMAIL_PURCHASE = 'email-purchase';
const TRIGGER_INCREASE_MAX_BID_CLICK = 'increase max bid click';
const TRIGGER_ITEM_SAVE = 'item save';

const INTERACTION_TYPE_DEALER_FAVORITING = 'dealer favoriting';
const INTERACTION_TYPE_ITEM_FAVORITING = 'item favoriting';
const INTERACTION_TYPE_AUCTION = 'auction';
const INTERACTION_TYPE_CONTACT_DEALER = 'contact dealer';
const INTERACTION_TYPE_SHIPPING_QUOTE = 'shipping quote';
const INTERACTION_TYPE_PDP_CHAT_BOX = 'pdp chat box';
const INTERACTION_TYPE_USER_REGISTRATION = 'user registration';
const INTERACTION_TYPE_USER_LOGIN = 'user login';
const INTERACTION_TYPE_METAMASK_WALLET_CONNECT = 'metamask wallet connect';
const INTERACTION_TYPE_NFT_AUCTION = 'nft auction';
const INTERACTION_TYPE_MAKE_OFFER = 'make offer';
const INTERACTION_TYPE_ADD_TO_CART = 'add to cart';
const INTERACTION_TYPE_ITEM_WATCH = 'item watch';
const INTERACTION_TYPE_TRADE_APPLICATION = 'trade application';
const INTERACTION_TYPE_FACET_SELECTION = 'results page facet selection';
const INTERACTION_TYPE_INTERNATIONAL = 'international';
const INTERACTION_TYPE_WATCH_ATTRIBUTE = 'watch attribute';
const INTERACTION_TYPE_PDP_SIDEBAR = 'pdp - sidebar';
const INTERACTION_TYPE_PDP_CHAT_BOX_SUGGESTION = 'pdp chat box - suggestion';
const INTERACTION_TYPE_PRICING_GUIDANCE_DISPLAYED = 'pricing section';
const INTERACTION_TYPE_PDP = 'pdp';
const INTERACTION_TYPE_PDP_ATTRIBUTE = 'pdp attribute';
const INTERACTION_TYPE_CALL_DEALER = 'call dealer';
const INTERACTION_TYPE_CONDENSED_PDP_SIDEBAR = 'condensed pdp - sidebar';
const INTERACTION_TYPE_CHECKOUT_SIDERAIL_INTERACTION = 'checkout siderail interaction';
const INTERACTION_TYPE_CHECKOUT_ABANDON_PAGE = 'abandon page modal';
const INTERACTION_TYPE_CHECKOUT_ABANDONED = 'abandoned checkout';
const INTERACTION_TYPE_CHECKOUT = 'checkout';

const STEP_INTERACTION_DEALER_ADDED = 'dealer added';
const STEP_INTERACTION_ITEM_ADDED = 'item added';
const STEP_INTERACTION_ITEM_ADDED_TO_FOLDER = 'item added to folder';
const STEP_INTERACTION_ITEM_REMOVED = 'item removed';
const STEP_INTERACTION_ENTRY = 'entry';
const STEP_INTERACTION_CONFIRM_BID_CLICK = 'confirm bid click';
const STEP_INTERACTION_COMPLETE = 'complete';
const STEP_INTERACTION_CONTINUE_CLICK = 'continue click';
const STEP_INTERACTION_EXIT = 'exit';
const STEP_INTERACTION_BID_MODAL_DISPLAY = 'bid modal display';
const STEP_INTERACTION_LARGE_BID_WARNING_DISPLAY = 'large bid warning displayed';
const STEP_INTERACTION_MAX_BID_MODAL_DISPLAY = 'increase max bid modal displayed';
const STEP_INTERACTION_MAX_BID_MODAL_CLICK = 'increase max bid click';
const STEP_INTERACTION_CONFIRM_MAX_BID_MODAL_CLICK = 'confirm increase max bid click';
const STEP_INTERACTION_LOGIN_ENTRY = 'login entry';
const STEP_INTERACTION_SHIPPING_LOCATION_UPDATE = 'shipping options location updated';
const STEP_INTERACTION_INTL_ZIP_CODE_ENTRY = 'intl zip code entry';
const STEP_INTERACTION_INTL_ZIP_CODE_COMPLETE = 'intl zip code complete';
const STEP_INTERACTION_PRODUCT = 'product';
const STEP_INTERACTION_OFFER_INQUIRY_ENTRY = 'offer inquiry entry';
const STEP_PRICING_GUIDANCE_DISPLAYED = 'pricing guidance displayed';
const STEP_PRICING_GUIDANCE_VIEW_MORE_CLICKED = 'pricing guidance view more click';
const STEP_ITEM_LISTING_PUBLISH_COMPLETE = 'item listing publish complete';
const STEP_INTERACTION_CHECKOUT_DEADEND = 'deadend error';

const STEP_INTERACTION_NFT_FROM_PDP = 'nft from pdp';
const STEP_INTERACTION_NFT_CREATOR_FROM_PDP = 'nft creator from pdp';
const STEP_INTERACTION_PRODUCT_FROM_PDP = 'product from pdp';
const STEP_INTERACTION_MAKE_OFFER = 'make offer click';
const STEP_INTERACTION_EMAIL_MAKE_OFFER = 'make offer click';
const STEP_INTERACTION_CONTINUE_MAKE_OFFER = 'make offer continue offer click';
const STEP_INTERACTION_ADD_TO_CART = 'purchase click';
const STEP_INTERACTION_SMS_OPTIN = 'sms opt-in displayed - v2';
const STEP_INTERACTION_APP_DOWNLOAD_DISPLAYED = 'app download displayed';
const STEP_INTERACTION_APP_DOWNLOAD_SUBMITTED = 'app download submitted';
const STEP_INTERACTION_ADD_AUCTION_EVENT_TO_CALENDAR_CLICK = 'add to calendar click';
const STEP_INTERACTION_ADD_AUCTION_EVENT_TO_CALENDAR_DISPLAY = 'add to calendar displayed';
const STEP_INTERACTION_VIEW_MOVEMENT_DESCRIPTION_CLICK = 'view movement descriptions click';
const STEP_INTERACTION_VIEW_RING_SIZE_CLICK = 'view ring size click';
const STEP_INTERACTION_RARE_FIND_PILL_CLICK = 'rare find pill click';
const STEP_INTERACTION_RARE_FIND_PILL_DISPLAY = 'rare find pill display';
const STEP_INTERACTION_FREE_SHIP_PILL_DISPLAY = 'free ship pill display';
const STEP_INTERACTION_TESTIMONIAL_CLICK = 'shop the most saved cta click';

const STEP_INTERACTION_ADDITIONAL_IMAGES_SUGGESTION_CLICK = 'additional_images click';
const STEP_INTERACTION_SHIPPING_SUGGESTION_CLICK = 'shipping click';
const STEP_INTERACTION_ITEM_DETAILS_SUGGESTION_CLICK = 'item_details click';
const STEP_INTERACTION_REQUEST_CUSTOMIZATION_SUGGESTION_CLICK = 'request_customization click';
const STEP_INTERACTION_NEGOTIATE_PRICE_SUGGESTION_CLICK = 'negotiate_price click';
const STEP_INTERACTION_ADDITIONAL_IMAGES_SUGGESTION_COMPLETE = 'additional_images complete';
const STEP_INTERACTION_SHIPPING_SUGGESTION_COMPLETE = 'shipping complete';
const STEP_INTERACTION_ITEM_DETAILS_SUGGESTION_COMPLETE = 'item_details complete';
const STEP_INTERACTION_REQUEST_CUSTOMIZATION_SUGGESTION_COMPLETE = 'request_customization complete';
const STEP_INTERACTION_NEGOTIATE_PRICE_SUGGESTION_COMPLETE = 'negotiate_price complete';
const STEP_INTERACTION_AUCTION_YOU_WON_DISPLAYED = 'auction you won displayed';
const STEP_INTERACTION_AUCTION_YOU_WON_CLICKED = 'auction you won clicked';
const STEP_INTERACTION_PDP_TAB_DISPLAY = 'pdp tab display';
const STEP_INTERACTION_PDP_TAB_CLICKED = 'pdp tab clicked';
const STEP_INTERACTION_VIEW_MORE_DETAILS_CLICK = 'view more details click';
const STEP_INTERACTION_VIEW_LESS_DETAILS_CLICK = 'view less details click';
const STEP_INTERACTION_ABANDON_CHECKOUT_RETURN_TO_ITEM = 'return to item click';
const STEP_INTERACTION_ABANDON_CHECKOUT_KEEP_CHECKING_OUT = 'keep checking out click';
const STEP_INTERACTION_ABANDON_CHECKOUT_BROWSER_MODAL = 'abandon browser modal display';

const STEP_TYPE_SHIPPING_ADDRESS = 'shipping address';
const STEP_TYPE_SHIPPING_METHOD = 'shipping method';
const STEP_TYPE_PAYMENT_METHOD = 'payment method';
const STEP_TYPE_ORDER_REVIEW = 'order review';

const METHOD_TYPE_PINTEREST = 'Pinterest';
const METHOD_TYPE_FACEBOOK = 'Facebook';
const METHOD_TYPE_WEBSITE = 'Website';
const METHOD_TYPE_INSTAGRAM = 'Instagram';
const METHOD_TYPE_TWITTER = 'Twitter';
const METHOD_TYPE_DISCORD = 'Discord';
const METHOD_TYPE_WIKIPEDIA = 'Wikipedia';

export const eventNameConstants = {
    EVENT_AB_TESTING,
    EVENT_AUCTION_BID,
    EVENT_PAYMENT_INFO,
    EVENT_WISHLIST,
    EVENT_SELECT_ITEM,
    EVENT_VIEW_ITEM,
    EVENT_VIEW_ITEM_LIST,
    EVENT_CONTACT_DEALER,
    EVENT_VIEW_PROMOTION,
    EVENT_SELECT_PROMOTION,
    EVENT_SIGN_UP,
    EVENT_LOGIN,
    EVENT_REGISTRATION,
    EVENT_SHARE,
    EVENT_PURCHASE,
    EVENT_PRODUCT_INTERACTION,
    EVENT_ADD_CART,
    EVENT_SEARCH,
    EVENT_PROMO_INTERACTION,
    EVENT_RESULT_INTERACTION,
    EVENT_ITEM_UPLOAD_INTERACTION,
    EVENT_BULK_ITEM_UPLOAD,
    EVENT_ITEM_UPLOAD_COMPLETE,
    EVENT_DASHBOARD_INTERACTION,
    EVENT_LISTING_INTERACTION,
    EVENT_CONTACT_1STDIBS,
    EVENT_INTL_INTERACTION,
    EVENT_CHECKOUT_INTERACTION,
    EVENT_NAVIGATION,
} as const;

export const triggerConstants = {
    TRIGGER_BID_CLICK,
    TRIGGER_BID_INCREASE,
    TRIGGER_PDP_PURCHASE,
    TRIGGER_PDP_MAKE_OFFER,
    TRIGGER_PRIVATE_OFFER,
    TRIGGER_MORE_FROM_DEALER,
    TRIGGER_CART_PURCHASE,
    TRIGGER_MY_ORDERS_ACCEPT_OFFER,
    TRIGGER_INVOICE_PURCHASE,
    TRIGGER_AUTOMATED_PRIVATE_OFFER,
    TRIGGER_EMAIL_MAKE_OFFER,
    TRIGGER_EMAIL_ACCEPT_OFFER,
    TRIGGER_EMAIL_PURCHASE,
    TRIGGER_INCREASE_MAX_BID_CLICK,
    TRIGGER_ITEM_SAVE,
} as const;

export const interactionTypeConstants = {
    INTERACTION_TYPE_DEALER_FAVORITING,
    INTERACTION_TYPE_ITEM_FAVORITING,
    INTERACTION_TYPE_ITEM_WATCH,
    INTERACTION_TYPE_AUCTION,
    INTERACTION_TYPE_CONTACT_DEALER,
    INTERACTION_TYPE_FACET_SELECTION,
    INTERACTION_TYPE_SHIPPING_QUOTE,
    INTERACTION_TYPE_PDP_CHAT_BOX,
    INTERACTION_TYPE_USER_LOGIN,
    INTERACTION_TYPE_USER_REGISTRATION,
    INTERACTION_TYPE_METAMASK_WALLET_CONNECT,
    INTERACTION_TYPE_NFT_AUCTION,
    INTERACTION_TYPE_MAKE_OFFER,
    INTERACTION_TYPE_ADD_TO_CART,
    INTERACTION_TYPE_TRADE_APPLICATION,
    INTERACTION_TYPE_INTERNATIONAL,
    INTERACTION_TYPE_WATCH_ATTRIBUTE,
    INTERACTION_TYPE_PDP_SIDEBAR,
    INTERACTION_TYPE_PDP_CHAT_BOX_SUGGESTION,
    INTERACTION_TYPE_PRICING_GUIDANCE_DISPLAYED,
    INTERACTION_TYPE_PDP,
    INTERACTION_TYPE_PDP_ATTRIBUTE,
    INTERACTION_TYPE_CALL_DEALER,
    INTERACTION_TYPE_CONDENSED_PDP_SIDEBAR,
    INTERACTION_TYPE_CHECKOUT_SIDERAIL_INTERACTION,
    INTERACTION_TYPE_CHECKOUT_ABANDON_PAGE,
    INTERACTION_TYPE_CHECKOUT_ABANDONED,
    INTERACTION_TYPE_CHECKOUT,
} as const;

export const stepInteractionConstants = {
    STEP_INTERACTION_DEALER_ADDED,
    STEP_INTERACTION_ITEM_ADDED,
    STEP_INTERACTION_ITEM_ADDED_TO_FOLDER,
    STEP_INTERACTION_ITEM_REMOVED,
    STEP_INTERACTION_ENTRY,
    STEP_INTERACTION_CONFIRM_BID_CLICK,
    STEP_INTERACTION_COMPLETE,
    STEP_INTERACTION_CONTINUE_CLICK,
    STEP_INTERACTION_EXIT,
    STEP_INTERACTION_BID_MODAL_DISPLAY,
    STEP_INTERACTION_LARGE_BID_WARNING_DISPLAY,
    STEP_INTERACTION_NFT_FROM_PDP,
    STEP_INTERACTION_NFT_CREATOR_FROM_PDP,
    STEP_INTERACTION_PRODUCT_FROM_PDP,
    STEP_INTERACTION_MAKE_OFFER,
    STEP_INTERACTION_EMAIL_MAKE_OFFER,
    STEP_INTERACTION_CONTINUE_MAKE_OFFER,
    STEP_INTERACTION_ADD_TO_CART,
    STEP_INTERACTION_SMS_OPTIN,
    STEP_INTERACTION_APP_DOWNLOAD_DISPLAYED,
    STEP_INTERACTION_APP_DOWNLOAD_SUBMITTED,
    STEP_INTERACTION_MAX_BID_MODAL_DISPLAY,
    STEP_INTERACTION_MAX_BID_MODAL_CLICK,
    STEP_INTERACTION_CONFIRM_MAX_BID_MODAL_CLICK,
    STEP_INTERACTION_LOGIN_ENTRY,
    STEP_INTERACTION_SHIPPING_LOCATION_UPDATE,
    STEP_INTERACTION_INTL_ZIP_CODE_ENTRY,
    STEP_INTERACTION_INTL_ZIP_CODE_COMPLETE,
    STEP_INTERACTION_ADD_AUCTION_EVENT_TO_CALENDAR_CLICK,
    STEP_INTERACTION_ADD_AUCTION_EVENT_TO_CALENDAR_DISPLAY,
    STEP_INTERACTION_VIEW_MOVEMENT_DESCRIPTION_CLICK,
    STEP_INTERACTION_VIEW_RING_SIZE_CLICK,
    STEP_INTERACTION_PRODUCT,
    STEP_INTERACTION_OFFER_INQUIRY_ENTRY,
    STEP_INTERACTION_RARE_FIND_PILL_CLICK,
    STEP_INTERACTION_RARE_FIND_PILL_DISPLAY,
    STEP_INTERACTION_FREE_SHIP_PILL_DISPLAY,
    STEP_INTERACTION_TESTIMONIAL_CLICK,
    STEP_INTERACTION_ADDITIONAL_IMAGES_SUGGESTION_CLICK,
    STEP_INTERACTION_SHIPPING_SUGGESTION_CLICK,
    STEP_INTERACTION_ITEM_DETAILS_SUGGESTION_CLICK,
    STEP_INTERACTION_REQUEST_CUSTOMIZATION_SUGGESTION_CLICK,
    STEP_INTERACTION_NEGOTIATE_PRICE_SUGGESTION_CLICK,
    STEP_INTERACTION_ADDITIONAL_IMAGES_SUGGESTION_COMPLETE,
    STEP_INTERACTION_SHIPPING_SUGGESTION_COMPLETE,
    STEP_INTERACTION_ITEM_DETAILS_SUGGESTION_COMPLETE,
    STEP_INTERACTION_REQUEST_CUSTOMIZATION_SUGGESTION_COMPLETE,
    STEP_INTERACTION_NEGOTIATE_PRICE_SUGGESTION_COMPLETE,
    STEP_PRICING_GUIDANCE_DISPLAYED,
    STEP_PRICING_GUIDANCE_VIEW_MORE_CLICKED,
    STEP_ITEM_LISTING_PUBLISH_COMPLETE,
    STEP_INTERACTION_AUCTION_YOU_WON_DISPLAYED,
    STEP_INTERACTION_AUCTION_YOU_WON_CLICKED,
    STEP_INTERACTION_PDP_TAB_DISPLAY,
    STEP_INTERACTION_PDP_TAB_CLICKED,
    STEP_INTERACTION_VIEW_MORE_DETAILS_CLICK,
    STEP_INTERACTION_VIEW_LESS_DETAILS_CLICK,
    STEP_INTERACTION_ABANDON_CHECKOUT_RETURN_TO_ITEM,
    STEP_INTERACTION_ABANDON_CHECKOUT_KEEP_CHECKING_OUT,
    STEP_INTERACTION_ABANDON_CHECKOUT_BROWSER_MODAL,
    STEP_INTERACTION_CHECKOUT_DEADEND,
} as const;

export const stepTypeConstants = {
    STEP_TYPE_SHIPPING_ADDRESS,
    STEP_TYPE_SHIPPING_METHOD,
    STEP_TYPE_PAYMENT_METHOD,
    STEP_TYPE_ORDER_REVIEW,
} as const;

export const methodTypeConstants = {
    METHOD_TYPE_PINTEREST,
    METHOD_TYPE_FACEBOOK,
    METHOD_TYPE_WEBSITE,
    METHOD_TYPE_INSTAGRAM,
    METHOD_TYPE_TWITTER,
    METHOD_TYPE_DISCORD,
    METHOD_TYPE_WIKIPEDIA,
} as const;
